<template>
  <div v-if="visible" class="chat-share-menu" :class="{ 'chat-share-menu--hover': hoverOnly && !guideActive }" @click.stop @mousedown.stop>
    <v-menu v-model="open" offset-y left :close-on-content-click="true" :close-on-click="!guideActive">
      <template #activator="{ on, attrs }">
        <v-btn ref="guideMenu" icon small class="chat-share-menu__button" v-bind="attrs" v-on="on" :aria-label="label" :title="label">
          <v-icon small>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
      <v-list dense>
        <div class="chat-share-menu__header">
          <v-icon small color="primary">{{ typeIcon }}</v-icon>
          <span><small>Élément à partager</small><strong>{{ typeLabel }}</strong></span>
        </div>
        <v-divider />
        <v-list-item ref="guideExisting" @click="share('existing')">
          <v-list-item-icon><v-icon small>mdi-chat-plus-outline</v-icon></v-list-item-icon>
          <v-list-item-title>Partager dans une discussion</v-list-item-title>
        </v-list-item>
        <v-list-item ref="guideNew" @click="share('new')">
          <v-list-item-icon><v-icon small>mdi-message-plus-outline</v-icon></v-list-item-icon>
          <v-list-item-title>Nouvelle discussion</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import { requestChatShare, resourceIcon, resourceTypeLabel } from './resources'
import guideTargets from './guideTargets'
import { guideState } from '../engine/guide/state'

export default {
  name: 'ChatShareMenu',
  mixins: [guideTargets],
  inject: { chatResourceEmbedded: { default: false } },
  props: {
    modalKey: { type: String, default: '' },
    reference: { type: Object, required: true },
    hoverOnly: { type: Boolean, default: true },
    label: { type: String, default: 'Partager dans le chat' }
  },
  data: () => ({ open: false }),
  computed: {
    guideActive() { return guideState.running || guideState.picking },
    typeLabel() {
      if (this.reference.type === 'tab') return 'Contenu de tabulation'
      if (this.reference.type === 'visual' && this.reference.context?.visual_key) return 'Visuel de tableau'
      const label = resourceTypeLabel(this.reference)
      if (this.reference.type !== 'module') return label
      const moduleLabel = this.$modules?.[this.reference.module_type]?.label
      const detail = typeof moduleLabel === 'string' ? moduleLabel.trim() : ''
      return detail ? `${label} · ${detail.charAt(0).toUpperCase()}${detail.slice(1)}` : label
    },
    typeIcon() {
      const moduleIcon = this.reference.type === 'module' && this.$modules?.[this.reference.module_type]?.settings?.icon
      return moduleIcon || resourceIcon(this.reference)
    },
    visible() {
      if (this.reference.type === 'module' && ['form', 'search', 'tabs', 'codebarre'].includes(this.reference.module_type)) return false
      return !this.chatResourceEmbedded && this.$store.getters.isAuth && this.$store.state.chat && !(this.$store.getters.currentUser || {}).public
    }
  },
  watch: { guideActive(active) { if (!active && this._openedByGuide) { this.open = false; this._openedByGuide = false } } },
  methods: {
    chatGuideTargets() {
      const reference = this.reference
      const suffix = reference.type === 'page' ? 'page' : `${reference.type}:${reference.action_id || reference.module_id || reference.tab_id || reference.context?.field_id || ''}`
      const key = `chat:share:${suffix}`
      const context = { modalKey: this.modalKey, pageId: reference.page_id }
      return [
        { key, ref: 'guideMenu', label: this.label, context, ready: () => this.visible, operations: { open: () => { this._openedByGuide = !this.open; this.open = true } } },
        { key: `${key}:existing`, ref: 'guideExisting', label: 'Partager dans une discussion', context, ready: () => this.visible && this.open, operations: { click: () => this.share('existing') } },
        { key: `${key}:new`, ref: 'guideNew', label: 'Nouvelle discussion', context, ready: () => this.visible && this.open, operations: { click: () => this.share('new') } }
      ]
    },
    share(mode) {
      requestChatShare(this.$store, this.modalKey, this.reference, mode)
      this.open = false
      this.$emit('shared', mode)
    }
  }
}
</script>

<style>
.chat-share-menu { display: inline-flex; flex: 0 0 auto; z-index: 3; }
.chat-share-menu__button { color: var(--app-chat-accent, #1976d2); background: var(--app-card, #fff); }
.chat-share-menu__header { display: flex; align-items: center; gap: 12px; padding: 9px 16px 12px; color: var(--app-chat-text, inherit); }
.chat-share-menu__header > span { display: flex; flex-direction: column; gap: 3px; }
.chat-share-menu__header small { font-size: 10px; color: var(--app-chat-muted, inherit); }
.chat-share-menu__header strong { font-size: 12px; font-weight: 600; }
.chat-share-menu--hover { opacity: 0; transition: opacity .15s ease; }
.chat-share-host:hover > .chat-share-menu--hover,
.chat-share-host:focus-within > .chat-share-menu--hover,
.chat-share-menu--hover:focus-within { opacity: 1; }
@media (hover: none), (pointer: coarse) { .chat-share-menu--hover { opacity: 1; } }
</style>
